"use strict";
/** @license See the LICENSE file. */
Object.defineProperty(exports, "__esModule", { value: true });
// This code is auto-generated, do not modify this file!
const version = '1.4.3';
exports.version = version;
//# sourceMappingURL=version.js.map